export let NavComputed = {
    shoppingCartLink() {
        const isAuth = this.$store.getters['User/isAuthenticated'];
        if (isAuth || this.findAttributeOnSiteInfo('cartType') == 1) {
            return {name: 'ShoppingCart'}
        }
        return {name: 'UnAuthenticatedShoppingCart'}
    },
}